module.exports = __webpack_public_path__ + "assets/64496d2fb215049b5e646e5b69747025.png";